import { render, staticRenderFns } from "./ExperienceBlock.vue?vue&type=template&id=fa822e0e"
import script from "./ExperienceBlock.vue?vue&type=script&lang=js"
export * from "./ExperienceBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports